import { Navigate } from "react-router-dom";
import { useAuth } from "../authContext/authContext";
import { CircularProgress, Box } from "@mui/material";

// Inverse of ProtectedRoute, for / and /login: a browser that
// already holds a session goes straight to the dashboard instead of being
// asked to log in again. An expired access token is fine here — the
// dashboard's first API call refreshes it via apiFetch, and only an
// expired/invalid refresh token sends the user back to /login.
const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicOnlyRoute;
